<template>
  <component :is="icon" :style="style" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  name: string
  size?: number
}>()

const icon = computed<unknown>(() => {
  const icons = import.meta.glob('/src/assets/icons/*.svg', { eager: true, query: 'component' })
  const icon = icons[`/src/assets/icons/${props.name}.svg`]
  // eslint-disable-next-line no-console
  if (!icon) console.error(`No such icon ${props.name}`)
  return icon
})

const style = computed(() => {
  if (props.size) return { width: `${props.size}px`, height: `${props.size}px` }
  return {}
})
</script>
